import { render, staticRenderFns } from "./studentPrivacyPolicy.vue?vue&type=template&id=41ea358c&scoped=true&"
var script = {}
import style0 from "./studentPrivacyPolicy.vue?vue&type=style&index=0&id=41ea358c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea358c",
  null
  
)

export default component.exports